import React from "react";
import { Typography, Grid, Container } from "@material-ui/core";
import { styleSheet } from "../../../assets/theme";
import { CustomAppBar, CustomButton } from "../../../shared";
import { getContent } from "../../../utils/helper";
import { priorityLanguage, supportedLanguageMapping } from "../constants";

const Language = ({ setLanguage, selectedLanguage, submit, languageJSON, supportedLanguages }) => {
   supportedLanguages =
      supportedLanguages &&
      supportedLanguages.sort((a, b) =>
         priorityLanguage.indexOf(a.language) < priorityLanguage.indexOf(b.language) ? -1 : 1
      );
   return (
      <div>
         <CustomAppBar
            title={getContent(languageJSON, "title_select_langauge")}
            leftButton={<div />}
            rightButton={<div />}
         />
         <Container style={{ backgroundColor: "#f7fdfd" }}>
            <Grid
               container
               justify="center"
               alignItems="center"
               style={{ padding: "2%", maxHeight: "100vh", overflow: "scroll", paddingBottom: 150 }}
               spacing={2}
            >
               {supportedLanguages.map((item, index) => (
                  <Grid key={index} item xs={6} md={3}>
                     <div
                        style={{
                           height: 100,
                           borderRadius: 10,
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           backgroundColor:
                              selectedLanguage === item.language ? styleSheet.palette.primary.main : "#f3f3f3",
                        }}
                        onClick={() => setLanguage("selectedLanguage", item.language)}
                     >
                        <Typography
                           variant="h6"
                           style={{
                              color: selectedLanguage === item.value ? styleSheet.palette.primary.contrastText : "#000",
                           }}
                        >
                           {supportedLanguageMapping[item.language]}
                        </Typography>
                     </div>
                  </Grid>
               ))}
            </Grid>
            <Grid
               container
               justify="center"
               alignItems="center"
               style={{ padding: "15px", position: "absolute", bottom: 0, left: 0, backgroundColor: "#f7fdfd" }}
            >
               <Grid item xs={11}>
                  <CustomButton
                     size="large"
                     disabled={!selectedLanguage}
                     variant="contained"
                     style={{ textAlign: "center", width: "100%", fontSize: 12 }}
                     color="primary"
                     handleChange={submit}
                     label={<Typography variant="button">{getContent(languageJSON, "action_next")}</Typography>}
                  />
               </Grid>
            </Grid>
         </Container>
      </div>
   );
};

export default Language;